export default {
  'Text': 'टेक्स्ट',
  'Styles': 'स्टाइल',
  'Text here': 'यहाँ टेक्स्ट डालें',
  'Add subtitles': 'टेक्स्ट डालें',
  'Text Color': 'टेक्स्ट का रंग',
  'Outline': 'आउटलाइन',
  'Background': 'बैकग्राउंड',
  'Position': 'स्थिति',
}